<template>
  <CFooter :fixed="false">
    <div class="footer-content">
      <a href="/" target="">FraudAvoid</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Scienlabs Technologies.</span>
      <span class="footer-links ml-3">
        <router-link to="/pages/privacy-policy" class="footer-link">Privacy Policy</router-link>
        <span class="footer-separator">|</span>
        <router-link to="/pages/cookie-policy" class="footer-link">Cookie Policy</router-link>
        <span class="footer-separator">|</span>
        <a href="#" @click.prevent="openCookieSettings" class="footer-link">Cookie Settings</a>
      </span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="http://scienlabs.com/?ref=fraudavoid" target="_blank">Scienlabs Technologies</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  methods: {
    openCookieSettings() {
      this.$store.dispatch('openCookiePreferences')
    }
  }
}
</script>

<style scoped>
.footer-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: inline-flex;
  align-items: center;
}

.footer-link {
  color: #73818f;
  text-decoration: none;
  transition: color 0.15s ease-in-out;
}

.footer-link:hover {
  color: #2f353a;
  text-decoration: underline;
}

.footer-separator {
  margin: 0 10px;
  color: #c8ced3;
}

@media (max-width: 576px) {
  .footer-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .footer-links {
    margin-top: 5px;
    margin-left: 0 !important;
  }
}
</style>
